import axios, { AxiosError } from "axios";
import { UseRefreshToken } from "../hooks/useRefreshToken";
import {v4 as uuidv4} from 'uuid';

export function getAPIClient() {
  const token  = localStorage.getItem("barte-auth-token");
  const { sendRefreshToken } = UseRefreshToken();

  const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
  });

  if (token) {
    api.interceptors.request.use((config: any) => {
      const newConfig = config;
      newConfig.headers.Authorization = `Bearer ${token}`;
      newConfig.headers.post['x-idempotency-key'] = uuidv4();
      return newConfig;
    });
  }

  api.interceptors.response.use(
    (response) => {
      return Promise.resolve(response);
    },
    (error: AxiosError) => {
      if (error?.response?.status === 401) {
        sendRefreshToken();
      } else if (error?.response?.status === 403) {
        // localStorage.removeItem("barte-auth-token");
        // window.location.replace(process.env.REACT_APP_FRONT_URL + "login");
      }
      return Promise.reject(error);
    }
  );
  return api;
}


export function getAPIBankingClient() {
  const token  = localStorage.getItem("barte-auth-token");
  const { sendRefreshToken } = UseRefreshToken();

  const api = axios.create({
    baseURL: process.env.REACT_APP_API_BANKING_URL,
  });

  if (token) {
    api.interceptors.request.use((config: any) => {
      const newConfig = config;
      newConfig.headers.Authorization = `Bearer ${token}`;
      newConfig.headers.post['x-idempotency-key'] = uuidv4();
      
      // Log detalhado da requisição
      console.log('=== API BANKING REQUEST ===');
      console.log('URL:', newConfig.baseURL + newConfig.url);
      console.log('Method:', newConfig.method);
      console.log('Headers:', newConfig.headers);
      console.log('Data:', newConfig.data);
      console.log('===========================');
      
      return newConfig;
    });
  }

  api.interceptors.response.use(
    (response) => {
      console.log('=== API BANKING SUCCESS ===');
      console.log('Status:', response.status);
      console.log('Data:', response.data);
      console.log('===========================');
      return Promise.resolve(response);
    },
    (error: AxiosError) => {
      console.error('=== API BANKING ERROR ===');
      console.error('URL:', error.config?.url);
      console.error('Method:', error.config?.method);
      console.error('Status:', error.response?.status);
      console.error('Response Data:', error.response?.data);
      console.error('Request Data:', error.config?.data);
      console.error('Headers:', error.response?.headers);
      console.error('Full Error:', error);
      console.error('========================');
      
      if (error?.response?.status === 401) {
        sendRefreshToken();
      } else if (error?.response?.status === 403) {
        localStorage.removeItem("barte-auth-token");
        window.location.replace(process.env.REACT_APP_FRONT_URL + "login");
      }
      return Promise.reject(error);
    }
  );
  return api;
}
